
export default [
  {
    path: '/order',
    name: 'order',
    component: () => import('views/order/order-list'),
    meta: {
      needToken: true,
    },
  },
  {
    path: '/order-detail',
    name: 'orderDetail',
    component: () => import('views/order/order-detail'),
    meta: {
      needToken: true,
    },
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    component: ()=>import('views/evaluate/evaluate'),
    meta: {
      needToken: true,
    },
  },
  {
    path: '/returns',
    name: 'returns',
    component: ()=>import('views/returns/returns'),
    meta: {
      needToken: true,
    },
  },
  {
    path: '/logistics',
    name: 'logistics',
    component: () => import('views/logistics/logistics'),
    meta: {
      needToken: true,
    }
  },
  {
    path: '/personal-info',
    name: 'personalInfo',
    component: () => import('views/mine/personal-info'),
    meta: {
      needToken: true
    }
  },
  {
    path: '/settle-in',
    name: 'settleIn',
    component: () => import('views/mine/settle-in'),
  },
  {
    path: '/settlein-list',
    name: 'settleInList',
    component: () => import('views/mine/settleIn-list')
  },
  {
    path: '/apply-distributor',
    name: 'applyDistributor',
    component: () => import('views/mine/apply-distributor'),
    meta: {
      needToken: true
    }
  }
];
